import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1AdminPositionMembershipIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {SessionContext} from "../../../../util/SessionContext";


class AdminPositionMembershipEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_position_memberships",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.AdminPositionMembership-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminPositionMembershipIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPositionMembership-001";
        payload.ShifamedMessage.AdminPositionMembership = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_position_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPositionMembership-001",
                "idoc-response": "v1.AdminPositionMembership-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminPositionMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let sessionContext = new SessionContext();

        let adminPositionMembership = {};

        adminPositionMembership["USID"] = this.getAttributeValue("USID");
        adminPositionMembership["SourceUSID"] = sessionContext.getGeneralPurposeVariable();
        adminPositionMembership["SourceType"] = "Project Plan";
        adminPositionMembership["PositionUSID"] = this.getAttributeValue("PositionUSID")

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPositionMembership-001";
        payload.ShifamedMessage.AdminPositionMembership = adminPositionMembership;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_position_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPositionMembership-001",
                "idoc-response": "v1.AdminPositionMembership-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminPositionMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        let adminPositionMembership = {};

        adminPositionMembership["USID"] = this.getAttributeValue("USID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPositionMembership-001";
        payload.ShifamedMessage.AdminPositionMembership = adminPositionMembership;

        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_position_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPositionMembership-001"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AdminPositionMembershipEnterpriseComponent;